import { render, staticRenderFns } from "./PontosMedicao.vue?vue&type=template&id=b68f921c&scoped=true&"
import script from "./PontosMedicao.vue?vue&type=script&lang=js&"
export * from "./PontosMedicao.vue?vue&type=script&lang=js&"
import style0 from "./PontosMedicao.vue?vue&type=style&index=0&id=b68f921c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68f921c",
  null
  
)

export default component.exports